type QueryObject = {
  [key: string]: string;
};

export const getQueryObject = (queryString: string) => {
  const queryObject: QueryObject = {};

  queryString
    .replace('?', '')
    .split('&')
    .forEach(keyValuePairString => {
      const keyValuePair = keyValuePairString.split('=');
      queryObject[keyValuePair[0]] = keyValuePair[1];
    });

  return queryObject;
};

const getQueryString = (queryParams: QueryObject) => {
  const arrayOfKeys = Object.keys(queryParams);
  if (!arrayOfKeys.length) {
    return '';
  }

  return `?${arrayOfKeys.map(key => `${key}=${queryParams[key]}`).join('&')}`;
};

export const createUrl = (location: Location, queryParams?: QueryObject) => {
  const queryString = queryParams ? getQueryString(queryParams) : '';

  return `${location.origin}${location.pathname}${queryString}`;
};

export const addQueryToHistory = (queryParams?: QueryObject) => {
  history.pushState(null, '', createUrl(window.location, queryParams));
};
